import UserManegmentList from './UserManegmentList';

export default UserManegmentList;
